'use es6';

export const APP_STARTED = 'APP_STARTED';